import { PlaygroundQueryPage } from './playground-query-page';

export type ResultView = NonNullable<PlaygroundQueryPage['resultView']>;

/** The endpoints whose rich Response view is switched on, for everyone. Any
 *  other endpoint shows its raw JSON in the Response tab, as before the
 *  views existed. Listed by endpoint, not view, since /search and /similar
 *  share one view; release one by adding it here. */
export const RELEASED_RESULT_VIEWS: ReadonlySet<string> = new Set(['/rag', '/search', '/similar', '/answer', '/image']);
